module.exports = __webpack_public_path__ + "images/application/templates/user-invite@2x-35a2a701.png";